import { Skeleton } from "@mui/material"
import React from "react"

export function CalendarSkeleton() {
  return (
    <div className='w-full h-screen p-4 flex flex-col bg-white rounded-lg'>
      {/* Toolbar with navigation */}
      <div className='flex mb-4 justify-between items-center'>
        <Skeleton
          animation='wave'
          variant='rounded'
          width='120px'
          height='40px'
        />
        <Skeleton
          animation='wave'
          variant='rounded'
          width='180px'
          height='40px'
        />
        <div className='flex gap-2'>
          <Skeleton
            animation='wave'
            variant='rounded'
            width='80px'
            height='40px'
          />
          <Skeleton
            animation='wave'
            variant='rounded'
            width='80px'
            height='40px'
          />
        </div>
      </div>

      {/* Calendar header */}
      <div className='flex mb-2  pb-2'>
        <Skeleton
          animation='wave'
          variant='rounded'
          width='100%'
          height='50px'
        />
      </div>

      {/* Calendar grid */}
      <div className='flex-1 grid grid-rows-10 gap-1'>
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
          <div key={n} className='flex gap-1'>
            <Skeleton
              animation='wave'
              variant='rounded'
              width='60px'
              height='100%'
            />
            <Skeleton
              animation='wave'
              variant='rounded'
              width='100%'
              height='100%'
            />
          </div>
        ))}
      </div>
    </div>
  )
}

